/** Common E.164 dial prefixes (longest match first for parsing). */
export const PHONE_DIAL_CODES: { value: string; label: string }[] = [
  { value: "+971", label: "UAE +971" },
  { value: "+966", label: "Saudi Arabia +966" },
  { value: "+974", label: "Qatar +974" },
  { value: "+973", label: "Bahrain +973" },
  { value: "+968", label: "Oman +968" },
  { value: "+965", label: "Kuwait +965" },
  { value: "+962", label: "Jordan +962" },
  { value: "+961", label: "Lebanon +961" },
  { value: "+972", label: "Israel +972" },
  { value: "+90", label: "Turkey +90" },
  { value: "+7", label: "Russia/KZ +7" },
  { value: "+380", label: "Ukraine +380" },
  { value: "+48", label: "Poland +48" },
  { value: "+49", label: "Germany +49" },
  { value: "+33", label: "France +33" },
  { value: "+39", label: "Italy +39" },
  { value: "+34", label: "Spain +34" },
  { value: "+31", label: "Netherlands +31" },
  { value: "+32", label: "Belgium +32" },
  { value: "+41", label: "Switzerland +41" },
  { value: "+43", label: "Austria +43" },
  { value: "+46", label: "Sweden +46" },
  { value: "+47", label: "Norway +47" },
  { value: "+45", label: "Denmark +45" },
  { value: "+358", label: "Finland +358" },
  { value: "+353", label: "Ireland +353" },
  { value: "+351", label: "Portugal +351" },
  { value: "+30", label: "Greece +30" },
  { value: "+44", label: "UK +44" },
  { value: "+61", label: "Australia +61" },
  { value: "+64", label: "New Zealand +64" },
  { value: "+65", label: "Singapore +65" },
  { value: "+60", label: "Malaysia +60" },
  { value: "+66", label: "Thailand +66" },
  { value: "+84", label: "Vietnam +84" },
  { value: "+63", label: "Philippines +63" },
  { value: "+62", label: "Indonesia +62" },
  { value: "+81", label: "Japan +81" },
  { value: "+82", label: "South Korea +82" },
  { value: "+86", label: "China +86" },
  { value: "+852", label: "Hong Kong +852" },
  { value: "+886", label: "Taiwan +886" },
  { value: "+91", label: "India +91" },
  { value: "+92", label: "Pakistan +92" },
  { value: "+880", label: "Bangladesh +880" },
  { value: "+94", label: "Sri Lanka +94" },
  { value: "+977", label: "Nepal +977" },
  { value: "+27", label: "South Africa +27" },
  { value: "+234", label: "Nigeria +234" },
  { value: "+254", label: "Kenya +254" },
  { value: "+20", label: "Egypt +20" },
  { value: "+55", label: "Brazil +55" },
  { value: "+52", label: "Mexico +52" },
  { value: "+54", label: "Argentina +54" },
  { value: "+1", label: "US/Canada +1" },
];

const SORTED_PREFIXES = Array.from(new Set(PHONE_DIAL_CODES.map((d) => d.value))).sort(
  (a, b) => b.length - a.length,
);

export function splitDialAndLocal(mobile: string | undefined | null): {
  dial: string;
  local: string;
} {
  const raw = (mobile ?? "").trim().replace(/\s+/g, " ");
  if (!raw) return { dial: "+1", local: "" };
  for (const prefix of SORTED_PREFIXES) {
    if (raw.startsWith(prefix)) {
      return {
        dial: prefix,
        local: raw.slice(prefix.length).replace(/\D/g, ""),
      };
    }
  }
  return { dial: "+1", local: raw.replace(/\D/g, "") };
}

export function joinDialAndLocal(dial: string, local: string): string {
  const d = dial || "+1";
  const digits = (local || "").replace(/\D/g, "");
  return `${d}${digits}`;
}
